/* tslint:disable */
/* eslint-disable */
/**
 * crm-screener-insurances
 * crm-screener-insurances
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * Captured at the point the Availity payer dropdown option couldn't be selected. Present only for PAYER_NOT_FOUND.
 * @export
 * @interface PalAuthSubmissionErrorDetailsPayerNotFound
 */
export interface PalAuthSubmissionErrorDetailsPayerNotFound {
    /**
     * 
     */
    payer_value: string;
    /**
     * 
     */
    facility_name: string;
    /**
     * 
     */
    region_name: string;
}

/**
 * Check if a given object implements the PalAuthSubmissionErrorDetailsPayerNotFound interface.
 */
export function instanceOfPalAuthSubmissionErrorDetailsPayerNotFound(value: object): value is PalAuthSubmissionErrorDetailsPayerNotFound {
    if (!('payer_value' in value) || value['payer_value'] === undefined) return false;
    if (!('facility_name' in value) || value['facility_name'] === undefined) return false;
    if (!('region_name' in value) || value['region_name'] === undefined) return false;
    return true;
}

export function PalAuthSubmissionErrorDetailsPayerNotFoundFromJSON(json: any): PalAuthSubmissionErrorDetailsPayerNotFound {
    return PalAuthSubmissionErrorDetailsPayerNotFoundFromJSONTyped(json, false);
}

export function PalAuthSubmissionErrorDetailsPayerNotFoundFromJSONTyped(json: any, ignoreDiscriminator: boolean): PalAuthSubmissionErrorDetailsPayerNotFound {
    if (json == null) {
        return json;
    }
    return {
        
        'payer_value': json['payer_value'],
        'facility_name': json['facility_name'],
        'region_name': json['region_name'],
    };
}

export function PalAuthSubmissionErrorDetailsPayerNotFoundToJSON(json: any): PalAuthSubmissionErrorDetailsPayerNotFound {
    return PalAuthSubmissionErrorDetailsPayerNotFoundToJSONTyped(json, false);
}

export function PalAuthSubmissionErrorDetailsPayerNotFoundToJSONTyped(value?: PalAuthSubmissionErrorDetailsPayerNotFound | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'payer_value': value['payer_value'],
        'facility_name': value['facility_name'],
        'region_name': value['region_name'],
    };
}

